import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {DesignRef} from '@mintdata-wsp/common/state/ui/publish/PublishState';
import {BindingState, IBindingsSnapshot} from '@mintdata-wsp/common/state/ui/visualDesigner/BindingState';
import {DesignState} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {SpreadsheetsState} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SpreadsheetsState';
import {ISurfaceStateSnapshot, SurfaceState} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/SurfaceState';
import {OpenDesignState} from '@mintdata-wsp/common/state/ui/visualDesigner/VisualDesignerState';
import {ViewportUtil} from '@mintdata-wsp/common/util/ViewportUtil';
import {pubControllers} from '@mintdata-wsp/pub/controllers/PubControllers';

import bind from 'bind-decorator';
import {runInAction} from 'mobx';

export class DesignController
{
    @bind
    public async loadDesign()
    {
        // we need designId in commonControllers.designState.onApplicationLoad
        const designRef = new DesignRef(null, pubControllers.integration.publishedApplicationId, null, null, null);
        const openDesign = new OpenDesignState(designRef, false, true);

        ViewportUtil.addViewportToVisualComponents();

        const designStateSnapshot = pubControllers.integration.designStateSnapshot;
        const surfaceSnapshot:ISurfaceStateSnapshot = designStateSnapshot.surface;
        const bindingsSnapshot:IBindingsSnapshot = designStateSnapshot.bindings;
        designStateSnapshot.surface = null;

        runInAction(() =>
        {
            commonControllers.designState.setOpenDesign(openDesign);
            commonControllers.designState.addHashListener();
            commonControllers.designState.addPostMessageListener();

            openDesign.designState = DesignState.fromJsonDeep(designStateSnapshot);
            openDesign.designState.surfaceSnapshot = surfaceSnapshot;

            if( !openDesign.designState.spreadsheets )
                openDesign.designState.spreadsheets = SpreadsheetsState.create();

            commonControllers.spreadsheets.main.initializeRootWorkbook();
        });

        // load bundles in parallel
        await commonControllers.artifacts.loadVisualArtifacts();

        await commonControllers.artifacts.resolveVisualComponents(surfaceSnapshot);

        runInAction(() =>
        {
            const designState = openDesign.designState;
            designState.surface = surfaceSnapshot ? SurfaceState.fromJsonDeep(surfaceSnapshot) : SurfaceState.create();
            designState.binding = bindingsSnapshot ? BindingState.fromJsonDeep(bindingsSnapshot, designState.spreadsheets, designState.surface) : BindingState.create();
            designState.surfaceSnapshot = null;
            this.disablePageLoader();
        });

        setTimeout(commonControllers.designState.onApplicationLoad);
    }

    @bind
    public disablePageLoader():void
    {
        const body = document.body;
        body && body.classList.remove('body-page-loader-bg');

        const loader = document.getElementById('page-loader');
        const loaderBg = document.getElementById('page-loader-bg');

        if( loaderBg ) loaderBg.remove();

        if( !loader ) return;

        loader.classList.add('page-loader-remove');

        setTimeout(() =>
        {
            loader.remove();
        }, 1100);
    }
}
